import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Sidebar({ isOpen, toggleSidebar, closeSidebar }) {
    const role = localStorage.getItem("role") || "user";
    const [openMenus, setOpenMenus] = useState({
        master: false,
        entry: false,
        reports: false,
        settings: false
    });

    const toggleMenu = (menu) => {
        setOpenMenus(prev => ({
            ...prev,
            [menu]: !prev[menu]
        }));
    };

    const handleLinkClick = () => {
        if (window.innerWidth < 768) {
            closeSidebar();
        }
    };

    return (
        <div 
            className={`bg-light border-end vh-100 sidebar-nav transition-all ${isOpen ? 'show' : ''}`} 
            style={{ 
                width: '250px', 
                zIndex: 2100,
                transition: 'all 0.3s ease'
            }}
        >
            <div className="sidebar-heading border-bottom p-3 d-flex justify-content-between align-items-center">
                <span className="fw-bold">Billing System</span>
                <button type="button" className="btn d-md-none" onClick={closeSidebar}>
                    <i className="bi bi-x-lg"></i>
                </button>
            </div>
            <div className="list-group list-group-flush overflow-auto" style={{ maxHeight: 'calc(100vh - 60px)' }}>
                {role === "customer" ? (
                    <div>
                        <div 
                            className="list-group-item list-group-item-action bg-dark text-white fw-bold d-flex justify-content-between align-items-center cursor-pointer py-3"
                            onClick={() => toggleMenu('reports')}
                            style={{ cursor: 'pointer' }}
                        >
                            <span><i className="bi bi-file-earmark-bar-graph me-2"></i> Reports</span>
                            <i className={`bi bi-chevron-${openMenus.reports ? 'up' : 'down'} small`}></i>
                        </div>
                        <div className={`collapse ${openMenus.reports ? 'show' : ''}`}>
                            <Link to="/customer/bills" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Service Invoice Report</Link>
                        </div>
                    </div>
                ) : (
                    <Link to="/dashboard" className="list-group-item list-group-item-action bg-light py-3 border-bottom" onClick={handleLinkClick}>
                        <i className="bi bi-speedometer2 me-2"></i> Dashboard
                    </Link>
                )}
                
                {/* Master Menu */}
                {role !== "customer" && (
                <div>
                    <div 
                        className="list-group-item list-group-item-action bg-dark text-white fw-bold d-flex justify-content-between align-items-center cursor-pointer py-3"
                        onClick={() => toggleMenu('master')}
                        style={{ cursor: 'pointer' }}
                    >
                        <span><i className="bi bi-folder2 me-2"></i> Master</span>
                        <i className={`bi bi-chevron-${openMenus.master ? 'up' : 'down'} small`}></i>
                    </div>
                    <div className={`collapse ${openMenus.master ? 'show' : ''}`}>
                        <Link to="/products" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Products</Link>
                        <Link to="/suppliers" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Suppliers</Link>
                        <Link to="/customers" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Customers</Link>
                        <Link to="/vehicles" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Vehicles</Link>
                    </div>
                </div>
                )}

                {/* Entry Menu */}
                {role !== "customer" && (
                <div>
                    <div 
                        className="list-group-item list-group-item-action bg-dark text-white fw-bold d-flex justify-content-between align-items-center cursor-pointer py-3"
                        onClick={() => toggleMenu('entry')}
                        style={{ cursor: 'pointer' }}
                    >
                        <span><i className="bi bi-pencil-square me-2"></i> Entry</span>
                        <i className={`bi bi-chevron-${openMenus.entry ? 'up' : 'down'} small`}></i>
                    </div>
                    <div className={`collapse ${openMenus.entry ? 'show' : ''}`}>
                        <Link to="/purchase" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Purchase</Link>
                        <Link to="/sale" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Service Invoice</Link>
                        <Link to="/receipt" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Payment Receipt</Link>
                        <Link to="/voucher" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Payment Voucher</Link>
                        <Link to="/expenses" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Expenses</Link>
                    </div>
                </div>
                )}

                {/* Reports Menu */}
                {role !== "customer" && (
                <div>
                    <div 
                        className="list-group-item list-group-item-action bg-dark text-white fw-bold d-flex justify-content-between align-items-center cursor-pointer py-3"
                        onClick={() => toggleMenu('reports')}
                        style={{ cursor: 'pointer' }}
                    >
                        <span><i className="bi bi-file-earmark-bar-graph me-2"></i> Reports</span>
                        <i className={`bi bi-chevron-${openMenus.reports ? 'up' : 'down'} small`}></i>
                    </div>
                    <div className={`collapse ${openMenus.reports ? 'show' : ''}`}>
                        <Link to="/reports/sale" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Service Sales Report</Link>
                        <Link to="/reports/purchase" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Purchase Report</Link>
                        <Link to="/reports/daily-summary" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Day Summary</Link>
                        <Link to="/reports/payments" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Payments</Link>
                        <Link to="/reports/customer-ledger" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Customer Ledger</Link>
                        <Link to="/reports/supplier-ledger" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Supplier Ledger</Link>
                        <Link to="/reports/expenses" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Expenses Report</Link>
                        <Link to="/reports/profit-loss" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Profit & Loss</Link>
                        <Link to="/reports/account" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Account Report</Link>
                        <Link to="/reports/stock" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Stock Report</Link>
                    </div>
                </div>
                )}

                {/* Settings Menu */}
                {role !== "customer" && (
                <div>
                    <div 
                        className="list-group-item list-group-item-action bg-dark text-white fw-bold d-flex justify-content-between align-items-center cursor-pointer py-3"
                        onClick={() => toggleMenu('settings')}
                        style={{ cursor: 'pointer' }}
                    >
                        <span><i className="bi bi-gear me-2"></i> Settings</span>
                        <i className={`bi bi-chevron-${openMenus.settings ? 'up' : 'down'} small`}></i>
                    </div>
                    <div className={`collapse ${openMenus.settings ? 'show' : ''}`}>
                        <Link to="/settings/user" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>User Setting</Link>
                        <Link to="/settings/firm" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Firm Setting</Link>
                        <Link to="/accounts" className="list-group-item list-group-item-action bg-light ps-4 py-2" onClick={handleLinkClick}>Accounts</Link>
                    </div>
                </div>
                )}
            </div>
        </div>
    );
}

export default Sidebar;
